import React, {useState} from "react"
import {Box, CircularProgress, InputAdornment, TextField, Typography} from "@mui/material"
import SearchIcon from "@mui/icons-material/Search"

import type {IdentifiableCustomer} from "../types"
import {MIN_QUERY_LENGTH, useCustomerSearch} from "../useCustomerSearch"

import {CandidateList} from "./CandidateCard"

function resultsTitle(count: number): string {
	return count > 1 ? `${count} customer records` : "Customer"
}

function CustomerSearch({
	alreadyShown = [],
	renderActions,
}: {
	alreadyShown?: string[]
	renderActions?: (customer: IdentifiableCustomer) => React.ReactNode
}) {
	const [query, setQuery] = useState("")
	const {results, loading, error} = useCustomerSearch(query)

	const trimmed = query.trim()
	const asked = trimmed.length >= MIN_QUERY_LENGTH
	const unseen = results.filter((result) => !alreadyShown.includes(result.CustomerID))
	const allShownAbove = results.length > 0 && unseen.length === 0

	return (
		<Box display="flex" flexDirection="column" gap={2}>
			<Typography variant="body2" fontWeight={600}>
				Search a customer
			</Typography>
			<TextField
				value={query}
				onChange={(event) => setQuery(event.target.value)}
				label="Name, email, phone, reference or secure code"
				size="small"
				fullWidth
				error={error !== ""}
				helperText={error}
				slotProps={{
					input: {
						endAdornment: (
							<InputAdornment position="end">
								{loading ? <CircularProgress size={20} /> : <SearchIcon color="disabled" />}
							</InputAdornment>
						),
					},
				}}
			/>
			{asked && !loading && error === "" && (
				<CandidateList
					customers={unseen}
					title={resultsTitle(unseen.length)}
					empty={allShownAbove ? "Every match is already shown above." : `No customer matches “${trimmed}”.`}
					renderActions={renderActions}
				/>
			)}
		</Box>
	)
}

export {CustomerSearch}
